import { Box, BoxProps } from '@chakra-ui/react';
import { FC, ReactNode } from 'react';
/**
 * @description A standard card container for content
 * @prop children
 */
export interface CardProps extends BoxProps {
  children: ReactNode;
}

export const Card: FC<CardProps> = ({ children, ...rest }): JSX.Element => (
  <Box
    borderWidth={['none', 'none', '1px']}
    borderRadius={['none', 'none', '8px']}
    borderColor="brand.monochromatic.200"
    px={[0, 0, 7]}
    py={5}
    w="full"
    {...rest}
  >
    {children}
  </Box>
);
